export default {
    page_title: "Kevi | Galería de Archivos",
    modal: {
        title: "Galeria de Archivos",
        subtitle: "Selecciona un archivo existente o sube uno nuevo",
        clear: "Limpiar",
        upload_button: "Subir",
        filter_all: "Todos",
        filter_image: "Imagenes",
        filter_video: "Videos",
        filter_audio: "Audios",
        filter_other: "Otros",
        loading_files: "Cargando archivos...",
        empty_state: "Todavia no tienes ningun archivo. Sube el primero ahora!",
        drop_here: "Suelta aqui para subir",
        upload_title: "Arrastra y suelta archivos aqui",
        upload_subtitle: "o haz clic para seleccionar (max. {0}MB por archivo)",
        upload_progress: "Progreso de subida",
        cancel: "Cancelar",
        use_file: "Usar archivo",
        icon_pdf: "PDF",
        icon_video: "VID",
        icon_audio: "AUD",
        icon_file: "FILE",
    },
    no_files_text: "Todavía no tienes ningún Archivo,",
    no_files_cta: "¡crea el primero ahora!",
    delete_confirm: {
        title: "Eliminar Archivo",
        question: "¿Estás seguro de que deseas eliminar el archivo <strong>{0}</strong>?",
        warning: "Si está siendo utilizado en alguna acción, la imagen no se mostrará.",
        irreversible: "Esta acción no se puede deshacer.",
    },
    search_placeholder: "Filtrar por Nombre de Archivo",
    upload_area: "Haz clic para subir o arrastra y suelta archivos aquí",
    copy_url: "Copiar URL",
    delete_button: "Eliminar",
    no_results_search: "Ningún archivo encontrado con <strong>{0}</strong>",
    no_results_filter: "Ningún archivo encontrado con este filtro",
    ai: {
        create_title: "Crear imagen con KeviAI",
        edit_title: "Editar imagen con KeviAI",
        back: "Volver",
        edit_prompt_label: "Que quieres cambiar en la imagen?",
        create_prompt_label: "Describe la imagen",
        prompt_placeholder: "Ej.: Una cafeteria acogedora con luz suave, estilo fotografia profesional",
        improve_prompt: "Mejorar prompt",
        generate_edit: "Generar edicion",
        improved_prompt_label: "Prompt mejorado (puedes editarlo)",
        choose_style: "Elegir estilo",
        choose_style_label: "Elige un estilo visual",
        generate_image: "Generar imagen",
        generating: "Generando imagen...",
        adjust: "Ajustar",
        save_to_gallery: "Guardar en la galeria",
        preview: "Vista previa",
        select_file: "Selecciona un archivo",
        preview_generated_here: "La imagen generada aparecera aqui",
        edit_with_keviai: "Editar con KeviAI",
        back_to_gallery: "Volver a la galeria",
        use_image: "Usar imagen",
        image_saved: "Imagen guardada en la galeria!",
        error_improve_prompt_unavailable: "No fue posible mejorar el prompt.",
        error_improve_prompt: "Error al mejorar el prompt. Intentalo de nuevo.",
        error_generate_image_unavailable: "No fue posible generar la imagen.",
        error_generate_image: "Error al generar la imagen. Intentalo de nuevo.",
        error_edit_image_unavailable: "No fue posible editar la imagen.",
        error_edit_image: "Error al editar la imagen. Intentalo de nuevo.",
        error_save_image: "Error al guardar la imagen en la galeria.",
        style: {
            realistic_title: "Fotografia realista",
            realistic_description: "Iluminacion natural, detalles nitidos, apariencia fotografica.",
            studio_title: "Producto en estudio",
            studio_description: "Fondo limpio, sombras suaves, foco en el producto.",
            illustration_title: "Ilustracion",
            illustration_description: "Trazos artisticos, aspecto ilustrado, colores equilibrados.",
            watercolor_title: "Acuarela",
            watercolor_description: "Texturas suaves, pinceladas y tonos de acuarela.",
            three_d_title: "3D",
            three_d_description: "Render 3D, volumen, materiales realistas.",
            minimal_title: "Minimalista",
            minimal_description: "Pocos elementos, composicion limpia, colores simples.",
        },
    },
    filter_label: "Tipo de Archivo",
    filter_options: {
        image: "Imagen",
        pdf: "PDF",
        video: "Vídeo",
        audio: "Audio",
        other: "Otro",
    },
    notifications: {
        url_copied: "¡URL copiada con éxito!",
        url_copy_error: "No fue posible copiar la URL.",
        upload_success: "¡Archivo(s) enviado(s) con éxito!",
        upload_error_title: "¡Error al enviar archivo(s)!",
        upload_error_message: "Error al enviar archivo(s), ¡inténtalo de nuevo más tarde!",
        oversized_files: "Archivos de más de 20MB:",
        load_error: "Error al cargar archivos. Intentalo de nuevo.",
        delete_success: "¡Archivo eliminado con éxito!",
        delete_error: "Error al eliminar el archivo. Inténtalo de nuevo.",
    },
};
